import { render, staticRenderFns } from "./CounterBlock.vue?vue&type=template&id=65439854&"
import script from "./CounterBlock.vue?vue&type=script&lang=js&"
export * from "./CounterBlock.vue?vue&type=script&lang=js&"
import style0 from "./CounterBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
